export class EmailNotification
{
    versionId:string=null;
    selectedFunctions:Array<any>=[];
    selectedEmployees:Array<any>=[];
    description:string=null;
    subject:string=null;
    refUrl:string=null;
}